<div class="close-button-header">
    <button class="transparent-button" type="button" (click)="closeJobOfferLibrary()" [attr.aria-label]="'CVDeepAnalyzer.jobOfferLibrary.close' | translate">&times;</button>

    <button class="conectio-rectangular-small-add selected-button" type="button" (click)="closeJobOfferLibrary()" [attr.aria-label]="'CVDeepAnalyzer.jobOfferLibrary.uploadButton' | translate">
        <img src="assets/Deep-CV/upload-file-CV.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.uploadButton' | translate }}" class="img-small" />
    </button>
</div>

<div class="save-job-offer-container">
    <div class="search-create-folder-container">
        <div class="input-container-search">
            <input
                type="text"
                class="input-search-folder"
                placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.searchPlaceholder' | translate }}"
                title="{{ 'CVDeepAnalyzer.jobOfferLibrary.searchPlaceholder' | translate }}"
                (input)="filterJobOffers($event)" />
            <img src="assets/Deep-CV/search.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.searchAlt' | translate }}" class="img-small img-search" /> 
        </div>
        <input #fileInput type="file" class="hidden-file-input"  (change)="onFileSelected($event)" />
        <button class="conectio-rectangular-small-add" type="button" (click)="fileInput.click()" [attr.aria-label]="'CVDeepAnalyzer.jobOfferLibrary.uploadButton' | translate">
            <img src="assets/Deep-CV/upload-file-white.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.uploadButton' | translate }}" class="img-small" *ngIf="!loading" />
            <img src="assets/spinner.gif" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.loading' | translate }}" class="img-auto-size" *ngIf="loading" />
        </button>
        <button type="button" (click)="toggleJobOffer()" class="conectio-rectangular-small-add" [attr.aria-label]="'CVDeepAnalyzer.jobOfferLibrary.toggleManual' | translate">
            <img src="assets/Deep-CV/more-icon.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.toggleManual' | translate }}" class="img-small" />
        </button>
    </div>
</div>

<div class="save-job-offer-container-files" *ngIf="!addingManual">
    <div class="save-job-offer-container-files-item-loading" *ngIf="loadingFiles">
        <img src="assets/spinner.gif" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.loading' | translate }}" class="img-big" />
    </div>
    <div class="save-job-offer-container-list" *ngIf="!loadingFiles">
        <div *ngFor="let item of jobOffers | keyvalue | orderKeyValueByDate">
            <div class="folder-item-date" *ngIf="item.value.length > 0">
                <span>{{ item.key }}</span>
            </div>
            <div class="folder-item" *ngFor="let jobOffer of item.value" (click)="PushSelectedJobOffer(jobOffer.id)" [class.selected-job-offer]="selectedJobOffer.includes(jobOffer.id)">
                <strong>{{ jobOffer?.preprocessed_json?.title ? jobOffer?.preprocessed_json?.title : jobOffer.file_name }}</strong>
                <div 
                    class="folder-points-menu-container folder-points-menu-trigger"
                    (mouseenter)="jobOffer.showMenu = true" 
                    (mouseleave)="jobOffer.showMenu = false" 
                >
                    <img *ngIf="!jobOffer.showMenu" src="assets/Deep-CV/3-points.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.moreOptions' | translate }}" class="img-small" />
                    <div 
                        *ngIf="jobOffer.showMenu" 
                        class="folder-menu-btns"
                        
                    >
                        <button mat-icon-button type="button" (click)="editJobOffer(jobOffer.id); $event.stopPropagation()" [title]="'CVDeepAnalyzer.jobOfferLibrary.actions.edit' | translate"><img src="assets/Deep-CV/boton-editar.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.actions.edit' | translate }}" class="img-auto-size" /></button>
                        <button mat-icon-button type="button" (click)="seeOffer(jobOffer.id); $event.stopPropagation()" [title]="'CVDeepAnalyzer.jobOfferLibrary.actions.view' | translate"><img src="assets/Deep-CV/see.png" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.actions.view' | translate }}" class="img-auto-size" /></button>
                        <button mat-icon-button type="button" (click)="deleteJobOffer(jobOffer.id); $event.stopPropagation()" [title]="'common.buttons.delete' | translate"><img src="assets/Deep-CV/borrar.png" alt="{{ 'common.buttons.delete' | translate }}" class="img-auto-size" /></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="save-job-offer-container-actions" *ngIf="!pushonlyJobOffers">
        <button mat-button color="primary" type="button" (click)="setSelectedJobOffer()" [disabled]="savingSelectedJobOffer">
            <span *ngIf="!savingSelectedJobOffer">{{ 'CVDeepAnalyzer.jobOfferLibrary.selectButton' | translate }}</span>
            <img src="assets/spinner.gif" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.loading' | translate }}" class="img-small" *ngIf="savingSelectedJobOffer">
        </button>
    </div>
</div>

<form [formGroup]="manualJobOfferForm" *ngIf="addingManual">
    <h2>{{ 'CVDeepAnalyzer.jobOfferLibrary.manualTitle' | translate }}</h2>
    <div class="save-job-offer-container-files">
        <div class="save-job-offer-container-files-item" *ngIf="loadingOffer">
            <img src="assets/spinner.gif" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.loading' | translate }}" class="img-small" />
            {{ 'CVDeepAnalyzer.jobOfferLibrary.loadingManualMessage' | translate }}
        </div>
        <div class="save-job-offer-container-files-item">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleName' | translate }}</h4>
            <input
                type="text"
                class="input-search-folder"
                formControlName="title"
                placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualName' | translate }}"
                title="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualName' | translate }}"
                 />
        </div>
        <div class="save-job-offer-container-files-item">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleDescription' | translate }}</h4>
            <textarea
                class="input-search-folder"
                formControlName="job_description"
                placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualDescription' | translate }}"
                title="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualDescription' | translate }}"
                style="width: 90%;"
                ></textarea>
        </div>
        <div class="save-job-offer-container-files-item">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleSkills' | translate }}</h4>
            <mat-form-field class="example-chip-list" appearance="fill" style="width: 90%;">
                <mat-label>{{ 'CVDeepAnalyzer.jobOfferLibrary.manualSkills' | translate }}</mat-label>
                <mat-chip-grid #chipList aria-label="Fruit selection" formControlName="skills_tools">
                  <mat-chip-row *ngFor="let skill of manualJobOfferForm.get('skills_tools')?.value"
                           [removable]="removable" (removed)="remove(skill)">
                    {{skill}}
                    <button matChipRemove *ngIf="removable">
                      <img src="assets/trash.png" style="width: 20px; height: 20px; margin-left: 10px; vertical-align: middle;" />
                    </button>
                  </mat-chip-row>
                  <input placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualSkills' | translate }}"
                         [matChipInputFor]="chipList"
                         [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                         [matChipInputAddOnBlur]="addOnBlur"
                         (matChipInputTokenEnd)="add($event)">
                </mat-chip-grid>
            </mat-form-field>
        </div>
        <div class="save-job-offer-container-files-item flex-direction-column">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleLanguages' | translate }}</h4>
            <mat-form-field appearance="fill" style="width: 90%;">
                <mat-label>{{ 'createJobOffer.step1.languages.selectLanguage' | translate }}</mat-label>
                <mat-select formControlName="idioms" >
                    <mat-option *ngFor="let lang of languages" [value]="lang.code">
                        {{ 'CVDeepAnalyzer.jobOfferLibrary.languages.' + lang.name | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 90%;">
                <mat-label>{{ 'createJobOffer.step1.languages.selectLevel' | translate }}</mat-label>
                <mat-select formControlName="idiomslevel" >
                    <mat-option [value]="'basic'">{{ 'createJobOffer.step1.languages.basic' | translate }}</mat-option>
                    <mat-option [value]="'intermediate'">{{ 'createJobOffer.step1.languages.intermediate' | translate }}</mat-option>
                    <mat-option [value]="'fluent'">{{ 'createJobOffer.step1.languages.fluent' | translate }}</mat-option>
                    <mat-option [value]="'native'">{{ 'createJobOffer.step1.languages.native' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 90%;">
                <mat-label>{{ 'createJobOffer.step1.languages.selectMandatory' | translate }}</mat-label>
                <mat-select formControlName="idioms_mandatory" >
                    <mat-option [value]="'optional'">{{ 'createJobOffer.step1.languages.optional' | translate }}</mat-option>
                    <mat-option [value]="'recommended'">{{ 'createJobOffer.step1.languages.recommended' | translate }}</mat-option>
                    <mat-option [value]="'required'">{{ 'createJobOffer.step1.languages.required' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <div class="addEducation" (click)="addidiom()" id = "addidiom" class="add-language-button">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.3337 7.33463H12.667V12.668H7.33366V15.3346H12.667V20.668H15.3337V15.3346H20.667V12.668H15.3337V7.33463ZM14.0003 0.667969C6.64033 0.667969 0.666992 6.6413 0.666992 14.0013C0.666992 21.3613 6.64033 27.3346 14.0003 27.3346C21.3603 27.3346 27.3337 21.3613 27.3337 14.0013C27.3337 6.6413 21.3603 0.667969 14.0003 0.667969ZM14.0003 24.668C8.12033 24.668 3.33366 19.8813 3.33366 14.0013C3.33366 8.1213 8.12033 3.33464 14.0003 3.33464C19.8803 3.33464 24.667 8.1213 24.667 14.0013C24.667 19.8813 19.8803 24.668 14.0003 24.668Z" fill="#7712E3"/>
                </svg>
                <span>{{ 'createJobOffer.step1.languages.addLanguages' | translate }}</span>
            </div>

            <div class="row2" *ngIf="manualJobOfferForm.get('languages')?.value?.length > 0" style="margin-top: 30px; justify-content: flex-start; text-align: left;">
                <div *ngFor="let idiom_tuple of manualJobOfferForm.get('languages')?.value" style="margin-right: 20px; margin-bottom: 10px;">
                    <p style="color: #2B343C;">{{ 'CVDeepAnalyzer.jobOfferLibrary.languages.' + get_lang(idiom_tuple.language) | translate }} - {{ "createJobOffer.step1.languages." + idiom_tuple.level.toLowerCase() | translate }} ({{ "createJobOffer.step1.languages." + idiom_tuple.mandatory.toLowerCase() | translate }}) <img src="assets/trash.png" style="width: 20px; height: 20px; margin-left: 10px; vertical-align: middle;" (click)="deleteidiom(idiom_tuple)"></p>
                </div>
            </div>
        </div>
        <div class="save-job-offer-container-files-item">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleYearsOfExperience' | translate }}</h4>
            <input
                type="number"
                class="input-search-folder"
                formControlName="years_of_experience_required"
                placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualYearsOfExperience' | translate }}"
                title="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualYearsOfExperience' | translate }}"
            />
        </div>
        <div class="save-job-offer-container-files-item">
            <h4 class="save-job-offer-container-files-item-title">{{ 'CVDeepAnalyzer.jobOfferLibrary.titleLocation' | translate }}</h4>
            <input
                type="text"
                class="input-search-folder"
                formControlName="location"
                placeholder="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualLocation' | translate }}"
                title="{{ 'CVDeepAnalyzer.jobOfferLibrary.manualLocation' | translate }}"
            />
        </div>
        <div class="save-job-offer-container-actions" *ngIf="!seeOfferdetected">
            <button mat-button color="primary" type="button" (click)="saveJobOffer()">
                <span *ngIf="!loadingManualJobOffer">{{ 'common.buttons.save' | translate }}</span>
                <span *ngIf="loadingManualJobOffer"><img src="assets/spinner.gif" alt="{{ 'CVDeepAnalyzer.jobOfferLibrary.loading' | translate }}" class="img-small"></span>
            </button>
        </div>
    </div>
</form>
